import React, { useState } from 'react';
import { Folder as FolderIcon } from '@mui/icons-material';
import styles from '../index.module.css';

// Derive a display status from the link flags.
// is_active === '0' => Revoked, is_expired === true => Expired, otherwise Active.
const getLinkStatus = (link) => {
  if (link.is_active === '0' || link.is_active === 0 || link.is_active === false) {
    return { label: 'Revoked', className: styles.linkStatusRevoked };
  }
  if (link.is_expired) {
    return { label: 'Expired', className: styles.linkStatusExpired };
  }
  return { label: 'Active', className: styles.linkStatusActive };
};

// `coverUrl`: derived preview image for the folder (see useFolderCovers).
//   undefined -> still resolving; '' -> resolved, no usable cover; string -> cover.
const LinkFolderCard = ({ link, onClick, coverUrl }) => {
  const displayName = link.label || 'Untitled Folder';
  const contributionCount = Number(link.contribution_count) || 0;
  const status = getLinkStatus(link);
  // Flip back to the plain icon if the signed URL fails to load.
  const [imgError, setImgError] = useState(false);

  const showCover = Boolean(coverUrl) && !imgError;

  const countDisplay = contributionCount > 0
    ? `${contributionCount} contribution${contributionCount === 1 ? '' : 's'}`
    : 'No contributions';

  return (
    <div
      className={styles.contributorFolderCard}
      onClick={() => onClick(link)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClick(link);
        }
      }}
    >
      {/* Thumbnail area - a cover image derived from folder contents when
          available, otherwise the plain folder icon. */}
      <div className={styles.folderThumbnailGrid}>
        <div className={`${styles.linkStatusBadge} ${status.className}`}>
          {status.label}
        </div>

        {showCover ? (
          <>
            <img
              src={coverUrl}
              alt=""
              loading="lazy"
              decoding="async"
              className={styles.linkCoverImage}
              onError={() => setImgError(true)}
            />
            {/* Keep a small folder glyph so a photo still reads as "a folder". */}
            <div className={styles.linkFolderBadge}>
              <FolderIcon />
            </div>
          </>
        ) : (
          <div className={styles.linkFolderIcon}>
            <FolderIcon />
          </div>
        )}
      </div>

      {/* Folder Info */}
      <div className={styles.folderInfo}>
        <div className={styles.folderName}>{displayName}</div>
        <div className={styles.folderCount}>{countDisplay}</div>
      </div>
    </div>
  );
};

export default LinkFolderCard;
